// extracted by mini-css-extract-plugin
export default {"selectWrapper":"VfdAQIyt","select":"SupIJ4xF"};